import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import TimetablePage, { loadTimetableData } from "./pages/TimetablePage";
import { InfoPage, loadFestivalInfo } from "./pages/InfoPage";
import { ArtistPage, loadArtistPageData } from "./pages/ArtistPage";
import { PerformancePage, loadPerformancePageData } from "./pages/PerformancePage";
import { StagePage, loadStagePageData } from "./pages/StagePage";
import { SearchPage, loadSearchPageData } from "./pages/SearchPage";
import MapPage, { loadMapPageData } from "./pages/MapPage";
import { BasePage } from "./pages/BasePage";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { isRemoteDataSource } from "./config/dataSource";

import AdminLayout, { loadAdminData } from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import EntityListPage from "./pages/admin/EntityListPage";
import EntityEditorPage from "./pages/admin/EntityEditorPage";

export const router = createBrowserRouter(
  [
    {
      element: <App />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          index: true,
          element: (
            <BasePage>
              <TimetablePage />
            </BasePage>
          ),
          loader: loadTimetableData,
        },
        {
          path: "info",
          element: <InfoPage />,
          loader: loadFestivalInfo,
        },
        {
          path: "artist/:id",
          element: <ArtistPage />,
          loader: loadArtistPageData,
        },
        {
          path: "performance/:id",
          element: <PerformancePage />,
          loader: loadPerformancePageData,
        },
        {
          path: "stage/:id",
          element: <StagePage />,
          loader: loadStagePageData,
        },
        {
          path: "search",
          element: (
            <BasePage>
              <SearchPage />
            </BasePage>
          ),
          loader: loadSearchPageData,
        },
        {
          path: "map",
          element: <MapPage />,
          loader: loadMapPageData,
        },
      ],
    },
    // Admin routes sit outside <App> so they get none of the mobile shell
    // (narrow container, bottom navbar, grain overlay, decorative background).
    ...(isRemoteDataSource()
      ? [
          {
            path: "admin/login",
            element: <AdminLogin />,
          },
          {
            path: "admin",
            element: <AdminLayout />,
            loader: loadAdminData,
            errorElement: <ErrorBoundary />,
            children: [
              { index: true, element: <AdminDashboard /> },
              { path: ":collection", element: <EntityListPage /> },
              { path: ":collection/:id", element: <EntityEditorPage /> },
            ],
          },
        ]
      : []),
  ],
  {
    basename: process.env.BASE_NAME || "/",
  },
);
